import Header1 from './components/Header/Header1';
import Header2 from './components/Header/Header2';
import Main from './components/Main/Main';
import Footer from './components/Footer/Footer';
import Pageup from './components/Pageup/Pageup';


function App() {
  return (
    <div className="App">
      <Header1 />
      <Header2 />
      <Main />
      <Footer />
      <Pageup />
    </div>
  );
}

export default App;
